var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Details',{attrs:{"item":_vm.task,"properties":_vm.properties},scopedSlots:_vm._u([{key:"item.taskState",fn:function(ref){
var value = ref.value;
var item = ref.item;
return [_vm._v(_vm._s(_vm.$t(("enums.TaskState." + value))))]}},{key:"item.taskDate",fn:function(ref){
var value = ref.value;
return [_vm._v(_vm._s(_vm.$d(value, 'short')))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }